module.exports = __webpack_public_path__ + "static/james-0a1199c2d3e0ee220cd39f00e39dd88b.jpg";